'use strict';

var events = {
  WORKER_CREATED: {
    src: 79,
    eventId: 101,
    params: {
      worker_id: 'worker_id'
    }
  },
  WORKER_TERMINATED: {
    src: 79,
    eventId: 102,
    params: {
      worker_id: 'worker_id'
    }
  },
  SCRIPT_LOAD: {
    src: 79,
    eventId: 103,
    params: {
      app_id: 'app_id',
      script_url: 'script_url',
      script_name: 'script_name',
      time_spent: 'time_spent'
    }
  },
  INIT_APP_FOR_PAGE: {
    src: 79,
    eventId: 105,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  CREATE_CONTROLLERS: {
    src: 79,
    eventId: 107,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  APP_PAGE_READY: {
    src: 79,
    eventId: 110,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  ALL_APPS_PAGE_READY: {
    src: 79,
    eventId: 109,
    params: {
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  }
};

module.exports = events;



// WEBPACK FOOTER //
// ./src/main/events.js